import styled from "styled-components";

export const ScoresList = styled.ol`
  padding-left: 0;
  list-style: none;
`;

export const ScoreLI = styled.li`
  font-size: 1rem;
  margin-bottom: 0.5rem;
`;
